import { render, staticRenderFns } from "./DepartmentsUpdate.vue?vue&type=template&id=26959329"
import script from "./DepartmentsUpdate.vue?vue&type=script&lang=js"
export * from "./DepartmentsUpdate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports